import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './styles.pcss';

export default function PrivacyModal(props) {
  const {
    handlePrivacyModalClick, setCustomScripts,
  } = props;
  const [acceptedPrivacy, setAcceptedPrivacy] = useState(false);

  useEffect(() => {
    const privacySession = window.sessionStorage.getItem('acceptedPrivacy');
    if (privacySession) {
      if (privacySession === 'true') {
        setAcceptedPrivacy(true);
      } else if (privacySession === 'false') {
        handlePrivacyModalClick();
      }
    }
  }, []);

  useEffect(() => {
    if (acceptedPrivacy) {
      handlePrivacyModalClick();
    }
  }, [acceptedPrivacy]);

  const handleRejectClick = () => {
    setAcceptedPrivacy(false);
    window.sessionStorage.setItem('acceptedPrivacy', 'false');
    handlePrivacyModalClick();
  };

  const handleAcceptClick = () => {
    setAcceptedPrivacy(true);
    window.sessionStorage.setItem('acceptedPrivacy', 'true');
  };

  return (
    <div className="privacy-modal">
      {acceptedPrivacy && setCustomScripts()}
      <h4 className="privacy-modal__text">
        Our site uses third party cookies in order to personalize content and analyze web traffic.
        Learn more by visiting
        our <a href="https://web.fountain.com/privacy" rel="noopener noreferrer" target="_blank">Privacy Policy</a> and <a href="https://web.fountain.com/tos" rel="noopener noreferrer" target="_blank">Terms of Service</a>.
      </h4>
      <div className="button-row">
        <div className="reject-button" role="button" onClick={handleRejectClick} onKeyDown={handleRejectClick} tabIndex="0">Reject</div>
        <div className="accept-button" role="button" onClick={handleAcceptClick} onKeyDown={handleRejectClick} tabIndex="-1">Accept All</div>
      </div>
    </div>
  );
}

PrivacyModal.propTypes = {
  handlePrivacyModalClick: PropTypes.func,
  setCustomScripts: PropTypes.func,
};

PrivacyModal.defaultProps = {
  handlePrivacyModalClick: () => {},
  setCustomScripts: () => {},
};
